export default "__VITE_ASSET__CN84pKdj__"